import defaultsDeep from 'lodash/defaultsDeep';

import defaultBg from './assets/backgrounds/HeroBackground-Option1-01.png';
import defaultBg2 from './assets/backgrounds/HeroBackground-Option2-01.png';
import defaultBg3 from './assets/backgrounds/HeroBackground-Option3-01.png';

import doDeployBg from './assets/backgrounds/Login-doDeploy2021.png';
import doDeployLogo from './assets/deploy-logo2x.png';

import { LoginVariant } from './interfaces/login';

interface VariantMap {
  [id: string]: LoginVariant;
}

const defaults = {
  type: 'default',
  textColor: 'white',
  background: {
    image: defaultBg,
    horizontalPosition: 'center',
    verticalPosition: 'center',
    height: '180px',
    width: '360px'
  }
};

export const newBg2 = defaultsDeep(
  {
    type: 'newBg2',
    background: {
      image: defaultBg2
    }
  },
  defaults
);

export const newBg3 = defaultsDeep(
  {
    type: 'newBg3',
    background: {
      image: defaultBg3
    }
  },
  defaults
);

export const doDeploy2021 = defaultsDeep(
  {
    type: 'doDeploy2021',
    background: {
      image: doDeployBg
    },
    image: doDeployLogo,
    title: 'POWER YOUR BUSINESS \n JUNE 29, 2021',
    subtitle:
      "Learn how to build businesses powered by \n cloud at DigitalOcean's virtual conference  \n #DOdeploy",
    button: {
      variation: 'primary',
      text: 'RSVP',
      url:
        'https://deploy.digitalocean.com/home?utm_medium=cloud&utm_source=login&utm_campaign=deploy-rsvp&utm_content=content'
    }
  },
  defaults
);

export const teamVariant = defaultsDeep(
  {
    type: 'team',
    title: 'Join your team on DigitalOcean!',
    subtitle:
      '{{name}} has invited you to join them. Sign in and start making waves with your team today!'
  },
  defaults
);

// These are for randomly choosing login variants
const loginVariants: VariantMap = {
  primary: defaults,
  doDeploy2021
};

export default loginVariants;
